// extracted by mini-css-extract-plugin
export default {"root":"Filter_root__gS4h8","active":"Filter_active__6PIBh"};